const { __ } = wp.i18n
document.addEventListener('DOMContentLoaded', function (e) {
  const ctaBlock = e.target.querySelector('.cta__block')

  if (ctaBlock) {
    const jsBtn = ctaBlock.querySelector('.js-btn')
    if (jsBtn) {
      ctaBlock.addEventListener('mouseenter', () => {
        jsBtn.classList.add('active')
      })

      ctaBlock.addEventListener('mouseleave', () => {
        jsBtn.classList.remove('active')
      })
    }
  }
})
